/**
 * description: 描述信息
 * author: bql
 * 2023/8/1 14:49
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectCycleApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-cycle'
    }

}